import React, {ComponentProps, Fragment} from 'react';
import {MemberTierIcon} from './MemberTierIcon';
import {SmartShopperTierIcon} from './SmartShopperTierIcon';
import {TrailblazerTierIcon} from './TrailblazerTierIcon';
import {EliteBuyerTierIcon} from './EliteBuyerTierIcon';
import AccountStore from 'src/stores/AccountStore';
import {Platform, StyleProp, ViewStyle, Image} from 'react-native';
import BuildTypes from 'src/constants/BuildTypeConstants';
import Settings from 'src/Settings';
import Styles from 'src/components/Styles';

export const rewardTierIconsByBuildType = {
  [BuildTypes.default]: {
    1: require('src/components/img/svg/rewards/payapp/PayMember.png'),
    2: require('src/components/img/svg/rewards/payapp/PaySmartShopper.png'),
    3: require('src/components/img/svg/rewards/payapp/PayTrailBlazer.png'),
    4: require('src/components/img/svg/rewards/payapp/PayEliteBuyer.png'),
  },
  [BuildTypes.canteen]: {
    1: require('src/components/img/svg/rewards/canteen/CanteenMember.png'),
    2: require('src/components/img/svg/rewards/canteen/CanteenSmartShopper.png'),
    3: require('src/components/img/svg/rewards/canteen/CanteenTrailBlazer.png'),
    4: require('src/components/img/svg/rewards/canteen/CanteenEliteBuyer.png'),
  },
  [BuildTypes.aramark]: {
    1: require('src/components/img/svg/rewards/aramark/AramarkMember.png'),
    2: require('src/components/img/svg/rewards/aramark/AramarkSmartShopper.png'),
    3: require('src/components/img/svg/rewards/aramark/AramarkTrailBlazer.png'),
    4: require('src/components/img/svg/rewards/aramark/AramarkEliteBuyer.png'),
  },
};

const tierImages = {
  1: MemberTierIcon,
  2: SmartShopperTierIcon,
  3: TrailblazerTierIcon,
  4: EliteBuyerTierIcon,
};

type UserRewardsTierIconProps = ComponentProps<typeof MemberTierIcon> & {
  tierName: string;
  style?: StyleProp<ViewStyle>;
  size?: number;
};

const UserRewardsTierIconComponent = ({
  tierName,
  ...props
}: UserRewardsTierIconProps) => {
  const tiers = AccountStore?.getRewardStatusTiers();
  const _tierLevelObj = tiers?.filter((item) => item.name === tierName)[0];
  const _level = _tierLevelObj?.tierLevel || 1;
  const webSize = props.size ?? Styles.Heights.webRewardImageHeight;

  if (Platform.OS === 'web') {
    const imageSource =
      rewardTierIconsByBuildType[Settings.buildType]?.[_level];

    return imageSource ? (
      <Image
        source={imageSource}
        style={[
          {
            width: webSize,
            height: webSize,
          },
          props.style,
        ]}
        resizeMode="contain"
      />
    ) : null;
  } else {
    const TierIcon = tierImages[_level] ?? Fragment;
    return <TierIcon {...props} />;
  }
};

export const UserRewardsTierIcon = React.memo(UserRewardsTierIconComponent);
